import Colors from '@polestar/component-warehouse-react/tokens/colors/Colors';
const MapUserLocationMarkerTheme = {
    mapUserLocationMarker: {
        light: {
            backgroundColor: Colors.accessibleSafetyOrange,
        },
        dark: {},
    },
};
export default MapUserLocationMarkerTheme;
